module.exports = __webpack_public_path__ + "assets/e66e38430d0d8dbae583d0c409de491e.mp3";